export default class IframeResizerEnum {
    static IFRAME_ELEMENT = '[data-element="iframe-resizer"]'
}
